/* eslint-disable react/jsx-pascal-case */
import Icon, { LockOutlined, UserOutlined, RedoOutlined, InstagramOutlined, FacebookOutlined, GlobalOutlined, SmileOutlined } from '@ant-design/icons';
import { Button, Form, Input, Row, Col, Card, Image, notification, Badge, QRCode, Typography, Space, Layout, Carousel, ConfigProvider, Radio, Checkbox, message } from 'antd';
import React, { useEffect, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useRef } from 'react';
import { url, client_id } from './setting'
import OTLogo from './OTLogo';
import IndustryLogo from './IndustryLogo';
import Carousel_news_ticker from '../cram_school/components/Carousel_news_ticker';
import { Mini_chatRoom } from '../cram_school/ChatRoom';
import { Image1, Image2, Image3, Image4 } from './CarouselImages';
import zh_TW from 'antd/es/locale/zh_TW';
import en from 'antd/es/locale/en_US';
import Language from '../language';
const loginLanguage = Language?.component.children.login
const { ConfigContext } = ConfigProvider;

const { Header, Content, Footer } = Layout;
const Login = ({
    user = null,
    logo = "keyTravel",
    setting = {
        forgotPassword: true,
        forgotAccount: true,
        lineLogin: true,
        signAccount: true,
        chatting: true,
        language: false,
        rememberMe: true
    },
    onChangeLanguage = () => { }
}) => {
    const configContext = useContext(ConfigContext);
    const language = configContext.locale.locale

    return (
        <Layout
            style={{
                minHeight: "100vh"
            }}
            className="layout"
        >
            <Content

            >
                <Row
                    style={{
                        paddingTop: "5vw",
                        paddingLeft: "3vw",
                        paddingRight: "3vw"
                    }}
                    gutter={[8, 8]}
                >

                    {
                        setting?.language
                        &&
                        <Col span={24}>
                            <Row justify={"end"}>
                                <Col>
                                    <Radio.Group
                                        value={configContext.locale}
                                        onChange={(e) => onChangeLanguage(e.target.value)}>
                                        <Radio.Button key="en" value={en}>
                                            English
                                        </Radio.Button>
                                        <Radio.Button key="cn" value={zh_TW}>
                                            中文
                                        </Radio.Button>
                                    </Radio.Group>
                                </Col>
                            </Row>
                        </Col>}
                    <Col span={24}>
                        <Row
                            gutter={[8, 8]}
                            justify={"space-between"}
                            align={"middle"}
                        >
                            <Col
                                xxl={12}
                                xl={12}
                                lg={12}
                                md={16}
                                sm={24}
                                xs={24}
                            >
                                <Badge.Ribbon
                                    style={{
                                        display: user ? "iniline" : "none"
                                    }}
                                    text={user}>
                                    <Card
                                        hoverable
                                    >
                                        <Col span={24}>
                                            <LoginFrame
                                                setting={
                                                    {
                                                        forgotPassword: true,
                                                        forgotAccount: true,
                                                        lineLogin: true,
                                                        signAccount: true,
                                                        ...setting
                                                    }
                                                }
                                                logo={logo}
                                            />
                                        </Col>
                                    </Card>
                                </Badge.Ribbon>
                            </Col>
                            <Col
                                xxl={12}
                                xl={12}
                                lg={12}
                                md={8}
                                sm={24}
                                xs={24}
                            >
                                <Row>
                                    <Col span={24}>
                                        <Card size='small'>
                                            <Carousel_news_ticker
                                                height={460}
                                                file_url={[Image1, Image2, Image3, Image4]}
                                            />
                                        </Card>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                    {setting?.chatting &&
                        <Mini_chatRoom
                            name="有任何問題嗎？你可以和我們即時交談"
                        />}
                </Row>
            </Content >
            <Footer
                style={{
                    textAlign: 'center',
                }}
            >
                <Row>
                    <Col span={24}>
                        <Space>
                            <InstagramOutlined
                                style={{
                                    fontSize: '2rem',
                                    // color:'#fff'
                                }}
                            />
                            <FacebookOutlined
                                style={{
                                    fontSize: '2rem',
                                    color: "#1a77f2"
                                }}
                                onClick={() => {
                                    window.open('https://www.facebook.com/profile.php?id=100090985007916', 'blank')
                                }}
                            />
                            <LineIcon
                                style={{
                                    fontSize: '2rem',
                                    color: "#17b705"
                                }}
                                onClick={() => {
                                    window.open('https://liff.line.me/1645278921-kWRPP32q/?accountId=971btxyi', 'blank')
                                }}
                            />
                            <GlobalOutlined
                                style={{
                                    fontSize: '2rem',
                                    color: "#f5743b"
                                }}
                                onClick={() => {
                                    window.open('https://orange-technic.com/index.php/en/zhi-neng-cang-chu-guan-li-xi-tong-wms', 'blank')
                                }}
                            />
                        </Space>
                    </Col>
                    <Col span={24}>
                        © Construction 2023 數位教育平台. All rights reserved.
                    </Col>
                </Row>
            </Footer>
        </Layout >

    );
};
const LoginFrame = ({
    lineLogin = true,
    logo = "OT",
    setting = {
        forgotPassword: true,
        forgotAccount: true,
        lineLogin: true,
        signAccount: true,
        chatting: true,
        language: false,
        rememberMe: true
    }
}) => {
    const configContext = useContext(ConfigContext);
    const language = configContext.locale.locale
    const [remember, setRemember] = useState(true)

    const line_login = lineLogin || false
    const [date_now] = useState(Date.now())
    const [refreshToken, setRefreshToken] = useState('')
    const [form] = Form.useForm();
    const line_login_ref = useRef(true);
    const [mode, setMode] = useState("login")
    const [forgotCodeRefreshToken, setForgotCodeRefreshToken] = useState('')
    const [reciprocalCount, setReciprocalCount] = useState(120)
    const [reciprocalID, setReciprocalID] = useState(null)
    const [forgotPasswordLevel, setForgotPasswordLevel] = useState("getUserInformation")

    const navigate = useNavigate();
    const onFinish = (values) => {
        localStorage.setItem("refresh_token", refreshToken.refresh_token)
        axios.post('/login', {
            account: values.username,
            password: values.password,
            code: values.code,
            refresh_token: refreshToken.refresh_token
        })
            .then(response => {
                line_login_ref.current = false
                navigate(response.data.href || `/warehousing/purchase`);
                localStorage.setItem("refresh_token", response.data.refresh_token)
                localStorage.setItem("lineBind", true)
            })
            .catch((error) => {
                openNotification('top')
            })
            .finally(() => {
            })

    };
    const onForgotUid = (values) => {
        axios.post('/home/user/forgot_uid', {
            ...values,
            code: values.code,
            refresh_token: forgotCodeRefreshToken?.refresh_token
        })
            .then(response => {
                if (response.data?.status === "success") {
                    message.success("已傳送至信箱中")
                    startCounting()

                }
                else {
                    let errorMessage = response.data?.message ? response.data?.message : ""
                    message.error(errorMessage)
                }
            })
            .catch((error) => {
            })
            .finally(() => {
            })
    }
    const onFinishForgotPassword = (value, level) => {
        console.log({ value, level })
        if (level === "getUserInformation") {
            let params = {
                ...value,
                staff_phone :value?.staff_phone ? value?.staff_phone:""
            }
            axios
                .get('/home/user/forgot_password',
                    {
                        params
                    }
                )
                .then(response => {
                    let status =response.data?.status
                    let message = response.data?.message
                    if (response.data?.refresh_token) {
                        setForgotCodeRefreshToken(response.data)
                        setForgotPasswordLevel('editUserPassword')
                    }
                    if(status === "failure"){
                        message.error(message)
                    }
                })
                .finally(() => {
                    if (line_login_ref.current)
                        setTimeout(() => get_line_login(), 1000)
                })
        }
        else if (level === "editUserPassword") {
            let data = {
                ...value,
                refresh_token:forgotCodeRefreshToken.refresh_token
            }
            axios
                .post('/home/user/forgot_password', data

                )
                .then(response => {
                    let responseStatus = response.data?.status
                    let responseMessage = response.data?.message
                    if (responseStatus=== "success") {
                        message.success("修改成功")
                        setMode('login')
                        setForgotPasswordLevel("getUserInformation")
                    }
                    else {
                        message.error(responseMessage)
                    }
                })
                .catch(()=>{
                    message.error("修改失敗")
                })
                .finally(() => {
                   
                })
        }
    }
    const openNotification = (placement) => {
        notification.warning({
            message: `登入失敗`,
            description:
                '帳號或是密碼輸入錯誤 請再試一次',
            placement,
        });
    };
    const downHandler = (value) => {
        if (value.code === "Enter") {
            form.submit()
        }
    }
    const get_line_login = () => {
        axios
            .get('/qrcode/login',
                {
                    params: {
                        result_code: date_now
                    }
                }
            )
            .then(response => {
                if (response.data?.refresh_token) {
                    line_login_ref.current = false
                    navigate(response.data.href || `/`);
                    localStorage.setItem("refresh_token", response.data.refresh_token)
                }

            })
            .finally(() => {
                if (line_login_ref.current)
                    setTimeout(() => get_line_login(), 1000)
            })
    }
    const getRefreshToken = (refresh_mode) => {
        axios
            .get('/refresh_token',
                {
                }
            )
            .then(response => {
                if (!refresh_mode) {
                    setRefreshToken(response.data)
                }
                else if (refresh_mode === "forgotCodeRefreshToken") {
                    setForgotCodeRefreshToken(response.data)
                }
            })
            .catch((error) => {
            })
            .finally(() => {
            })
    }
    const onRememberChange = (remember) => {
        setRemember(pre => remember)
        let item = form.getFieldsValue()
        if (remember) {
            localStorage.setItem("username", item?.username)
            localStorage.setItem("password", item?.password)
        }
        else {
            localStorage.removeItem("username")
            localStorage.removeItem("password")
        }
    }
    const onRememberLoading = () => {
        let username = localStorage.getItem("username")
        let password = localStorage.getItem("password")
        if (username && password) {
            console.log("true")
            setRemember(pre => true)
            form.setFieldsValue({
                username: username,
                password: password
            })
        }
        else {
            setRemember(pre => false)
        }
    }
    const startCounting = () => {
        let countID = setInterval(() => {
            setReciprocalCount(pre => pre - 1)
        }, 1000)
        setReciprocalID(countID)
    }
    const stopCounting = () => {
        clearInterval(reciprocalID)
        setReciprocalCount(120)
    }

    useEffect(() => {
        if (setting?.lineLogin) {
            get_line_login()
        }
        getRefreshToken()
        document.title = "登入"
        onRememberLoading()
        window.addEventListener("keydown", downHandler);
        return () => {
            window.removeEventListener("keydown", downHandler);
            stopCounting()
        };
    }, [])
    useEffect(() => {
        form.resetFields()
        if (mode === "forgotUsername" || mode === "forgotPassword") {
            getRefreshToken("forgotCodeRefreshToken")
        }
        if (mode !== "forgotUsername") {
            stopCounting()
        }

    }, [mode])
    useEffect(() => {
        if (reciprocalCount === 0) {
            stopCounting()
        }

    }, [reciprocalCount])
    return (
        <Row gutter={[16, 32]}>

            <Col
                span={24}
            >
                {
                    logo === "OT" && <Image
                        preview={false} src={OTLogo}
                    >
                    </Image>
                }
                {
                    logo === "keyTravel" && <Typography.Title>
                        {
                            loginLanguage.children['NKNU e-Learning Platform'][language]
                        }
                    </Typography.Title>
                }
            </Col>
            {
                mode === "login" &&
                (<Col span={24}>
                    <Form
                        name="normal_login"
                        className="login-form"
                        initialValues={{
                            remember: true,
                        }}
                        onFinish={onFinish}
                        form={form}
                    >
                        <Row gutter={[4, 4]}>
                            <Col
                                xxl={16}
                                xl={16}
                                lg={16}
                                md={16}
                                sm={16}
                                xs={24}
                            >
                                <Row gutter={[4, 4]}>
                                    <Col span={24}>
                                        <Row justify={"space-between"}>
                                            <Space>

                                                <Col >
                                                    <Form.Item
                                                        name="username"
                                                        rules={[
                                                            {
                                                                required: true,
                                                                message: '請輸入你的帳戶名稱',
                                                            },
                                                        ]}
                                                    >
                                                        <Input prefix={<UserOutlined className="site-form-item-icon" />} placeholder="名稱" />
                                                    </Form.Item>
                                                </Col>
                                                <Col>
                                                    {
                                                        setting?.forgotAccount &&
                                                        <Form.Item >
                                                            <Button
                                                                type='link'
                                                                onClick={() => setMode("forgotUsername")}
                                                            >
                                                                {loginLanguage.children.forgot_account[language]}
                                                            </Button>
                                                        </Form.Item>
                                                    }

                                                </Col>
                                            </Space>
                                        </Row>
                                    </Col>
                                    <Col span={24}>
                                        <Row justify={"space-between"}>
                                            <Space>
                                                <Col >
                                                    <Form.Item
                                                        name="password"
                                                        rules={[
                                                            {
                                                                required: true,
                                                                message: '請輸入你的密碼',
                                                            },
                                                        ]}
                                                    >
                                                        <Input.Password
                                                            prefix={<LockOutlined className="site-form-item-icon" />}
                                                            // type="password"
                                                            placeholder="密碼"
                                                        />
                                                    </Form.Item>
                                                </Col>
                                                <Col>
                                                    {
                                                        setting?.forgotPassword &&
                                                        <Form.Item >
                                                            <Button type='link'
                                                                onClick={() => setMode("forgotPassword")}
                                                            >
                                                                {loginLanguage.children.forgot_password[language]}
                                                            </Button>
                                                        </Form.Item>
                                                    }

                                                </Col>
                                            </Space>

                                        </Row>
                                    </Col>
                                    <Col span={24}>
                                        <Form.Item>
                                            <Checkbox
                                                checked={remember}
                                                onChange={(e) => { onRememberChange(e.target.checked) }}
                                            >
                                                {loginLanguage.children.remember_me[language]}
                                            </Checkbox>
                                        </Form.Item>
                                    </Col>
                                    <Col span={24}>
                                        <Row>
                                            <Col >
                                                <Form.Item >
                                                    <img style={{ "height": "50px" }} class="input-group-addon" src={`${refreshToken.code}`} id="code_pic" />
                                                </Form.Item>
                                            </Col>
                                            <Col>
                                                <Form.Item >
                                                    <Button
                                                        onClick={getRefreshToken}
                                                        icon={<RedoOutlined />}
                                                        type='link'>
                                                        {loginLanguage.children.reorganize[language]}
                                                    </Button>
                                                </Form.Item>
                                            </Col>
                                        </Row>
                                    </Col>

                                    <Col
                                        xxl={12}
                                        xl={12}
                                        lg={16}
                                        md={16}
                                        sm={16}
                                        xs={16}
                                    >
                                        <Form.Item
                                            name="code"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: '請輸入驗證碼',
                                                },
                                            ]}
                                        >

                                            <Input
                                                type="text"
                                                placeholder="驗證碼"
                                                autoComplete={"off"}
                                            />
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Col>

                            {setting?.lineLogin ? (
                                <Col
                                    xxl={8}
                                    xl={8}
                                    lg={8}
                                    md={8}
                                    sm={8}
                                    xs={24}
                                    style={{
                                        alignSelf: 'start'
                                    }}
                                >
                                    <Row gutter={[8, 8]}
                                        justify={{
                                            xxl: 'start',
                                            xl: 'start',
                                            lg: 'start',
                                            md: 'start',
                                            sm: 'start',
                                            xs: 'center'
                                        }}
                                    >
                                        <Space direction='vertical'>
                                            <Col>
                                                <Space direction='vertical'>
                                                    <Typography.Text>
                                                        {loginLanguage.children.QRcode_login_message[language]}
                                                    </Typography.Text>
                                                    <Typography.Text>
                                                        {loginLanguage.children.need_bind_message[language]}
                                                    </Typography.Text>
                                                </Space>

                                            </Col>
                                            <Col>
                                                <QRCode
                                                    value={'https://access.line.me/oauth2/v2.1/authorize?response_type=code&client_id='+client_id+'&redirect_uri='+url+'&state=' + date_now + '&scope=profile%20openid&nonce=' + date_now}
                                                />
                                            </Col>
                                        </Space>

                                    </Row>

                                </Col>
                            )
                                : <Col
                                    xxl={8}
                                    xl={8}
                                    lg={8}
                                    md={8}
                                    sm={8}
                                    xs={0}
                                >
                                    <Space
                                        align='center'
                                        direction='vertical'>
                                        <SmileOutlined
                                            style={{
                                                color: "#fed39a",
                                                fontSize: "8vw"
                                            }}
                                        />
                                        <Typography.Title
                                            style={{
                                                color: "#417586"
                                            }}
                                        >
                                            {loginLanguage.children?.welcome[language]}
                                        </Typography.Title>
                                    </Space>
                                </Col>
                            }
                        </Row>
                        <Row gutter={[8, 8]}
                            justify="center"
                        >
                            <Col span={12}>
                                <Button
                                    type="primary"
                                    onClick={() => form.submit()}
                                    className="login-form-button"
                                    block
                                >
                                    {loginLanguage.children?.login[language]}
                                </Button>
                            </Col>
                            {
                                setting?.signAccount &&
                                (
                                    <Col span={12}>
                                        <Button
                                            style={{
                                                backgroundColor: "#e5e5e5"
                                            }}
                                            type="default"
                                            onClick={() => setMode("signUp")}
                                            block
                                        >
                                            {loginLanguage.children?.register[language]}
                                        </Button>
                                    </Col>
                                )
                            }

                        </Row>
                    </Form>
                </Col>)
            }
            {
                mode === "signUp" &&
                (<Col span={24}>
                    <Form
                        name="normal_login"
                        className="login-form"
                        initialValues={{
                            remember: true,
                        }}
                        onFinish={onFinish}
                        form={form}
                        labelCol={{
                            span: 6
                        }}
                        wrapperCol={{
                            span: 12
                        }}
                        autoComplete='off'
                    >
                        <Row gutter={[4, 4]}>
                            <Col
                                xxl={24}
                                xl={24}
                                lg={24}
                                md={24}
                                sm={24}
                                xs={24}
                            >
                                <Row gutter={[4, 4]}>
                                    <Col span={24}>
                                        <Form.Item
                                            label="帳戶名稱"
                                            name="username"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: '請輸入你的帳戶名稱',
                                                },
                                            ]}
                                            autoComplete="off"
                                        >
                                            <Input placeholder="帳戶名稱" />
                                        </Form.Item>
                                    </Col>
                                    <Col span={24}>
                                        <Col >
                                            <Form.Item
                                                label="密碼"
                                                name="password"
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: '請輸入你的密碼',
                                                    },
                                                ]}
                                            >
                                                <Input.Password
                                                    placeholder="密碼"
                                                />
                                            </Form.Item>
                                        </Col>
                                    </Col>
                                    <Col span={24}>

                                        <Form.Item
                                            name="confirm"
                                            label="確認密碼"
                                            dependencies={['password']}
                                            hasFeedback
                                            rules={[
                                                {
                                                    required: true,
                                                    message: '請再一次輸入確認密碼',
                                                },
                                                ({ getFieldValue }) => ({
                                                    validator(_, value) {
                                                        if (!value || getFieldValue('password') === value) {
                                                            return Promise.resolve();
                                                        }
                                                        return Promise.reject(new Error('兩次密碼並不符合'));
                                                    },
                                                }),
                                            ]}
                                        >
                                            <Input.Password />
                                        </Form.Item>
                                    </Col>
                                    <Col span={24}>
                                        <Form.Item
                                            label="信箱"
                                            name="email"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: '請輸入信箱',
                                                },
                                                {
                                                    type: 'email',
                                                    message: '這不是一個信箱格式',
                                                },

                                            ]}
                                        >
                                            <Input
                                            />
                                        </Form.Item>
                                    </Col>
                                    <Col span={24}>
                                        <Form.Item
                                            label="手機"
                                            name="cellphone"
                                        >
                                            <Input
                                            />
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <Row gutter={[8, 8]}
                            justify="center"
                        >
                            <Col span={12}>
                                <Button
                                    type="primary"
                                    onClick={() => setMode("login")}
                                    block
                                >
                                    返回登入
                                </Button>
                            </Col>
                            <Col span={12}>
                                <Button
                                    style={{
                                        backgroundColor: "#e5e5e5"
                                    }}
                                    type="default"
                                    // onClick={() => form.submit()}
                                    block
                                >
                                    確定註冊
                                </Button>
                            </Col>
                        </Row>
                    </Form>
                </Col>)
            }
            {
                mode === "forgotUsername" &&
                (<Col span={24}>
                    <Row justify={"center"}>
                        <Col >
                            <Typography.Title level={5}>
                                忘記帳號了嗎？請輸入註冊時的信箱及電話號碼，讓我們協助您找回帳號
                            </Typography.Title>
                        </Col>

                        <Col span={24}>
                            <Form
                                name="normal_login"
                                className="login-form"
                                initialValues={{
                                    remember: true,
                                }}
                                onFinish={onForgotUid}
                                form={form}
                                labelCol={{
                                    span: 6
                                }}
                                wrapperCol={{
                                    span: 12
                                }}
                                autoComplete='off'
                            >
                                <Row gutter={[4, 4]}>
                                    <Col
                                        xxl={24}
                                        xl={24}
                                        lg={24}
                                        md={24}
                                        sm={24}
                                        xs={24}
                                    >
                                        <Row gutter={[4, 4]}>
                                            <Col span={24}>
                                                <Form.Item
                                                    label="信箱"
                                                    name="user_email"
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: '請輸入信箱',
                                                        },
                                                        {
                                                            type: 'email',
                                                            message: '這不是一個信箱格式',
                                                        },

                                                    ]}
                                                >
                                                    <Input
                                                    />
                                                </Form.Item>
                                            </Col>
                                            <Col span={24}>
                                                <Form.Item
                                                    label="手機"
                                                    name="staff_phone"
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: '請輸入手機號碼',
                                                        },
                                                    ]}
                                                >
                                                    <Input
                                                    />
                                                </Form.Item>
                                            </Col>
                                            <Col
                                                xxl={24}
                                                xl={24}
                                                lg={24}
                                                md={24}
                                                sm={24}
                                                xs={24}
                                            >
                                                <Form.Item
                                                    label={"驗證碼"}
                                                    name="code"
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: '請輸入驗證碼',
                                                        },
                                                    ]}
                                                >

                                                    <Input
                                                        type="text"
                                                        placeholder="驗證碼"
                                                        autoComplete={"off"}
                                                    />
                                                </Form.Item>
                                            </Col>
                                            <Col span={24}>
                                                <Row>
                                                    <Col span={6}>

                                                    </Col>
                                                    <Col >
                                                        <Form.Item >
                                                            <img style={{ "height": "50px" }} class="input-group-addon" src={`${forgotCodeRefreshToken?.code}`} id="code_pic" />
                                                        </Form.Item>
                                                    </Col>
                                                    <Col>
                                                        <Form.Item >
                                                            <Button
                                                                onClick={() => getRefreshToken("forgotCodeRefreshToken")}
                                                                icon={<RedoOutlined />}
                                                                type='link'>
                                                                {loginLanguage.children.reorganize[language]}
                                                            </Button>
                                                        </Form.Item>
                                                    </Col>
                                                </Row>
                                            </Col>

                                        </Row>
                                    </Col>
                                </Row>

                            </Form>
                        </Col>

                        <Col span={24}>
                            <Row gutter={[8, 8]}
                                justify="center"
                            >
                                <Col span={24}>
                                    {reciprocalCount !== 120 &&
                                        <Typography.Title level={5}>
                                            若沒有收到電子郵件，請在120秒後再試一次，或是檢查有無在垃圾信箱中
                                        </Typography.Title>
                                    }

                                </Col>
                                <Col span={12}>
                                    <Button
                                        type="primary"
                                        onClick={() => setMode("login")}
                                        block
                                    >
                                        返回登入
                                    </Button>
                                </Col>
                                <Col span={12}>
                                    <Button
                                        style={{
                                            backgroundColor: "#e5e5e5"
                                        }}
                                        type="default"
                                        onClick={() => form.submit()}
                                        block
                                        disabled={reciprocalCount !== 120}
                                    >
                                        送出{reciprocalCount !== 120 && `(${reciprocalCount})`}
                                    </Button>
                                </Col>
                            </Row>
                        </Col>
                    </Row>

                </Col>)
            }
            {
                mode === "forgotPassword" &&
                (<Col span={24}>
                    <Row justify={"center"}>
                        <Col >
                            <Typography.Title level={5}>
                                {forgotPasswordLevel === "getUserInformation"
                                    ? `忘記密碼了嗎？請輸入註冊時的信箱，讓我們協助您登入系統` :
                                    `請輸入信件中的驗證碼並變更密碼`}
                            </Typography.Title>
                        </Col>
                        <Col span={24}>
                            <Form
                                name="normal_login"
                                className="login-form"
                                initialValues={{
                                    remember: true,
                                }}
                                onFinish={(values)=>onFinishForgotPassword(values,forgotPasswordLevel)}
                                form={form}
                                labelCol={{
                                    span: 6
                                }}
                                wrapperCol={{
                                    span: 12
                                }}
                                autoComplete='off'
                            >
                                {
                                    forgotPasswordLevel === "getUserInformation" &&
                                    <Row gutter={[4, 4]}>
                                        <Col span={24}>
                                            <Form.Item
                                                label="帳戶名稱"
                                                name="user_uid"
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: '請輸入你的帳戶名稱',
                                                    },
                                                ]}
                                                autoComplete="off"
                                            >
                                                <Input placeholder="帳戶名稱" />
                                            </Form.Item>
                                        </Col>
                                        <Col span={24}>
                                            <Form.Item
                                                label="信箱"
                                                name="user_email"
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: '請輸入信箱',
                                                    },
                                                    {
                                                        type: 'email',
                                                        message: '這不是一個信箱格式',
                                                    },

                                                ]}
                                            >
                                                <Input
                                                placeholder="EX:XXX@mail.com"
                                                />
                                            </Form.Item>
                                        </Col>
                                        <Col span={24}>
                                            <Form.Item
                                                label="手機"
                                                name="staff_phone"
                                                // rules={[
                                                //     {
                                                //         required: true,
                                                //         message: '請輸入手機號碼',
                                                //     },
                                                // ]}
                                            >
                                                <Input
                                                placeholder="EX:09xxxxxxxx"
                                                
                                                />
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                }
                                {
                                    forgotPasswordLevel === "editUserPassword" &&
                                    <Row gutter={[4, 4]}>
                                        <Col span={24}>
                                            <Form.Item
                                                hidden={true}
                                                label="帳戶名稱"
                                                name="user_uid"
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: '請輸入你的帳戶名稱',
                                                    },
                                                ]}
                                                autoComplete="off"
                                            >
                                                <Input placeholder="帳戶名稱" />
                                            </Form.Item>
                                        </Col>
                                        <Col
                                            xxl={24}
                                            xl={24}
                                            lg={24}
                                            md={24}
                                            sm={24}
                                            xs={24}
                                        >
                                            <Form.Item
                                                label={"驗證碼"}
                                                name="code"
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: '請輸入驗證碼',
                                                    },
                                                ]}
                                            >

                                                <Input
                                                    type="text"
                                                    placeholder="驗證碼"
                                                    autoComplete={"off"}
                                                />
                                            </Form.Item>
                                        </Col>
                                        <Col span={24}>
                                            <Form.Item
                                                label="新密碼"
                                                name="password"
                                                rules={[
                                                    {
                                                        required: true,
                                                    },
                                                ]}
                                                autoComplete="off"

                                            >
                                                <Input.Password />
                                            </Form.Item>


                                        </Col>
                                        <Col span={24}>
                                            <Form.Item
                                                label="確認新密碼"
                                                name="password1"
                                                dependencies={['password']}
                                                rules={[
                                                    {
                                                        required: true,
                                                    },
                                                    ({ getFieldValue }) => ({
                                                        validator(_, value) {
                                                            if (!value || getFieldValue('password') === value) {
                                                                return Promise.resolve();
                                                            }
                                                            return Promise.reject(new Error('輸入的密碼不相符'));
                                                        },
                                                    }),
                                                ]}
                                            >
                                                <Input.Password />
                                            </Form.Item>
                                        </Col>

                                    </Row>
                                }


                            </Form>
                        </Col>
                        <Col span={24}>
                            <Row gutter={[8, 8]}
                                justify="center"
                            >
                                <Col span={12}>
                                    <Button
                                        type="primary"
                                        onClick={() => setMode("login")}
                                        block
                                    >
                                        返回登入
                                    </Button>
                                </Col>
                                <Col span={12}>
                                    <Button
                                        style={{
                                            backgroundColor: "#e5e5e5"
                                        }}
                                        type="default"
                                        onClick={() => form.submit()}
                                        block
                                    >
                                        送出
                                    </Button>
                                </Col>
                            </Row>
                        </Col>
                    </Row>

                </Col>)

            }

        </Row>
    )
}
const LineIcon = ({
    style = {
    },
    onClick = () => {

    }
}) => (
    <Icon
        onClick={onClick}
        style={{
            ...style
        }}
        component={LineSvg}
    />
)
const LineSvg = ({
    width = "1rem",
    height = "1rem",
    color = "#17b705"
}) => (
    <svg t="1692807712061"
        class="icon"
        viewBox="0 0 1024 1024"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        p-id="4251"
        id="mx_n_1692807712061"
        width={width}
        height={height}
        fill={color}
    >
        <path
            d="M826.24 420.821333a26.922667 26.922667 0 0 1 0 53.802667H751.36v48h74.88a26.88 26.88 0 1 1 0 53.717333h-101.802667a26.922667 26.922667 0 0 1-26.752-26.837333V345.941333c0-14.72 12.032-26.88 26.88-26.88h101.802667a26.88 26.88 0 0 1-0.128 53.76H751.36v48h74.88z m-164.48 128.682667a26.88 26.88 0 0 1-26.922667 26.752 26.368 26.368 0 0 1-21.76-10.666667l-104.234666-141.525333v125.44a26.88 26.88 0 0 1-53.632 0V345.941333a26.752 26.752 0 0 1 26.624-26.794666c8.32 0 16 4.437333 21.12 10.837333l105.045333 142.08V345.941333c0-14.72 12.032-26.88 26.88-26.88 14.72 0 26.88 12.16 26.88 26.88v203.562667z m-244.949333 0a26.965333 26.965333 0 0 1-26.922667 26.837333 26.922667 26.922667 0 0 1-26.752-26.837333V345.941333c0-14.72 12.032-26.88 26.88-26.88 14.762667 0 26.794667 12.16 26.794667 26.88v203.562667z m-105.216 26.837333H209.792a27.050667 27.050667 0 0 1-26.88-26.837333V345.941333c0-14.72 12.16-26.88 26.88-26.88 14.848 0 26.88 12.16 26.88 26.88v176.682667h74.922667a26.88 26.88 0 0 1 0 53.717333M1024 440.064C1024 210.901333 794.24 24.405333 512 24.405333S0 210.901333 0 440.064c0 205.269333 182.186667 377.258667 428.16 409.941333 16.682667 3.498667 39.381333 11.008 45.141333 25.173334 5.12 12.842667 3.370667 32.682667 1.621334 46.08l-6.997334 43.52c-1.92 12.842667-10.24 50.602667 44.757334 27.52 55.082667-22.997333 295.082667-173.994667 402.602666-297.6C988.842667 614.101333 1024 531.541333 1024 440.064"
            p-id="4252">
        </path>
    </svg>
)

export default Login;